import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_ERFASSUNG_ART, KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { isTrue } from 'src/utils/helper';
import { InhaltWrapper } from '../../../antrag-components/Wrapper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureSkizzeFinanzierungPlanGlobal } from '../../global-structure/finanzierung-plan-skizze/TreeStructureSkizzeFinanzierungPlanGlobal';
import { TreestructureFoerderprojekteSkizzeGlobal } from '../../global-structure/foerderprojekte-skizze/TreestructureFoerderprojekteSkizzeGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureSkizzeVerbundpartnerGlobal } from '../../global-structure/verbundpartner-skizze/TreeStructureSkizzeVerbundpartnerGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import ProjektDatenSkizzeLoewe, { getFormStrucProjektDatenSkizzeLoewe } from './content/ProjektDatenSkizzeLoewe';
import EinnahmeUebersichtSkizzeLoewe from './content/einnahme/EinnahmeUebersichtSkizzeLoewe';
import { GetEigenmittelSkizzeLoewe } from './content/einnahme/GetEigenmittelSkizzeLoewe';
import { GetPersonalKostenSkizzeLoewe } from './content/personalkosten/GetPersonalKostenSkizzeLoewe';
import PersonalkostenUebersichtSkizzeLoewe from './content/personalkosten/PersonalkostenUebersichtSkizzeLoewe';
import AusgangssituationSkizzeLoewe, { getFormStrucAusgangssituationSkizzeLoewe } from './content/projektbeschreibung/AusgangssituationSkizzeLoewe';
import EntwicklungsvVorhabenSkizzeLoewe, {
	getFormStrucEntwicklungsvVorhabenSkizzeLoewe,
} from './content/projektbeschreibung/EntwicklungsvVorhabenSkizzeLoewe';
import InnovationsgradSkizzeLoewe, { getFormStrucInnovationsgradSkizzeLoewe } from './content/projektbeschreibung/InnovationsgradSkizzeLoewe';
import MarktAusblickSkizzeLoewe, { getFormStrucMarktAusblickSkizzeLoewe } from './content/projektbeschreibung/MarktAusblickSkizzeLoewe';
import SWOTSkizzeLoewe, { getFormStrucSWOTSkizzeLoewe } from './content/projektbeschreibung/SWOTSkizzeLoewe';
import WissenschaftlicheEffekteSkizzeLoewe, {
	getFormStrucWissenschaftlicheEffekteSkizzeLoewe,
} from './content/projektbeschreibung/WissenschaftlicheEffekteSkizzeLoewe';
import { GetSachkostenSkizzeLoewe } from './content/sachkosten/GetSachkostenSkizzeLoewe';
import SachkostenUebersichtSkizzeLoewe from './content/sachkosten/SachkostenUebersichtSkizzeLoewe';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureSkizzeLoewe = (
	application: any,
	kostenKategories: any,
	readOnly: boolean,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [];

	const externeSkizze = get(application, P.Allgemein_Erfassungsart.path, '') === ANTRAGS_ERFASSUNG_ART.Manuell;

	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	if (isTrue(externeSkizze)) {
		treeNodes = [
			...TreeStructureAllgemeinHinweisGlobal(application),
			{
				label: 'Projektdaten',
				content: <ProjektDatenSkizzeLoewe hasComment={hasCommentProjektdaten} />,
				formStruc: getFormStrucProjektDatenSkizzeLoewe(application),
				hasComment: hasCommentProjektdaten,
			},
			// Abschluss Global
			...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		];
	} else {
		treeNodes = [
			// Allgemeine Hinweise Global
			...TreeStructureAllgemeinHinweisGlobal(application),
			// Projektdaten
			{
				label: 'Projektdaten',
				content: <ProjektDatenSkizzeLoewe hasComment={hasCommentProjektdaten} />,
				formStruc: getFormStrucProjektDatenSkizzeLoewe(application),
				hasComment: hasCommentProjektdaten,
			},
			// Antragsteller Global
			...TreeStructureAntragstellerGlobal(application, readOnly),
			// Verbundpartner Global
			...TreeStructureSkizzeVerbundpartnerGlobal(application, readOnly),
			// Selbsterlärung-KMU Global
			...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
			// Beihilferelevanz-Erklärungen Global
			...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
			// RUS-Erklärungen Global
			...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
			// Deminismis-Selbsterklärung Global
			...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
			// Foerderprojekt Übersicht
			...TreestructureFoerderprojekteSkizzeGlobal(application, readOnly),
			// Projektbeschreibung
			...ProjektBeschreibungStructure(application, readOnly),
			// Zeitplanung Global
			...TreeStructureZeitplanungGlobal(application, readOnly),
			// Kosten
			...PersonalKostenStructure(application, kostenKategories, readOnly, isKostenEditable),
			...SachKostenStructure(application, kostenKategories, readOnly, isKostenEditable),
			...EigenmittelStructure(application, kostenKategories, readOnly, isKostenEditable),
			// Finanzierungplan Global
			...TreeStructureSkizzeFinanzierungPlanGlobal(application, isKostenEditable),
			// Anlagen Global
			...TreeStructureAnlagenGlobal(application, readOnly),
			// Erklärung Global
			...TreeStructureErklaerungGlobal(application, readOnly),
			// Abschluss Global
			...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
			// Bescheid Global
			...TreeStructureAntragBescheidGlobal(application),
		];
	}

	return treeNodes;
};

const ProjektBeschreibungStructure = (application: any, readOnly: boolean) => {
	const hasCommentAusgangssituation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
	);
	const hasCommentTechnologisch = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path,
	);
	const hasCommentinnovationsgrad = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Pruefstatus.path,
	);
	const hasCommentMarktanalyse = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Marktanalyse_Pruefstatus.path,
	);
	const hasCommentWissenschaftlicheEffekte = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path,
	);
	const hasCommentSWOT = checkIfHasComment(readOnly, application, P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Pruefstatus.path);
	let nodes: TreeNodeType[] = [
		{
			label: 'Projektbeschreibung',
			content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
			hasComment:
				(
					hasCommentAusgangssituation ||
					hasCommentTechnologisch ||
					hasCommentinnovationsgrad ||
					hasCommentMarktanalyse ||
					hasCommentWissenschaftlicheEffekte ||
					hasCommentSWOT
				) ?
					true
				:	false,
			children: [
				{
					label: 'Ausgangssituation',
					content: <AusgangssituationSkizzeLoewe hasComment={hasCommentAusgangssituation} />,
					hasComment: hasCommentAusgangssituation,
					formStruc: getFormStrucAusgangssituationSkizzeLoewe(application),
				},
				{
					label: 'Technologische Beschreibung',
					content: <EntwicklungsvVorhabenSkizzeLoewe hasComment={hasCommentTechnologisch} />,
					hasComment: hasCommentTechnologisch,
					formStruc: getFormStrucEntwicklungsvVorhabenSkizzeLoewe(application),
				},
				{
					label: 'Innovationsgrad und Alleinstellungsmerkmale',
					content: <InnovationsgradSkizzeLoewe hasComment={hasCommentinnovationsgrad} />,
					hasComment: hasCommentinnovationsgrad,
					formStruc: getFormStrucInnovationsgradSkizzeLoewe(application),
				},
				{
					label: 'Marktausblick / Verwertung',
					content: <MarktAusblickSkizzeLoewe hasComment={hasCommentMarktanalyse} />,
					hasComment: hasCommentMarktanalyse,
					formStruc: getFormStrucMarktAusblickSkizzeLoewe(application),
				},
				{
					label: 'Wissenschaftliche Effekte',
					content: <WissenschaftlicheEffekteSkizzeLoewe hasComment={hasCommentWissenschaftlicheEffekte} />,
					hasComment: hasCommentWissenschaftlicheEffekte,
					formStruc: getFormStrucWissenschaftlicheEffekteSkizzeLoewe(application),
				},
				{
					label: 'SWOT',
					content: <SWOTSkizzeLoewe hasComment={hasCommentSWOT} />,
					hasComment: hasCommentSWOT,
					formStruc: getFormStrucSWOTSkizzeLoewe(application),
				},
			],
		},
	];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		return [
			{
				label: 'Personalausgaben',
				content: <ApplicationHeading title='Personalausgaben' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				children: GetPersonalKostenSkizzeLoewe(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Personalausgaben Übersicht',
				content: <PersonalkostenUebersichtSkizzeLoewe />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		return [
			{
				label: 'Sachausgaben',
				content: <ApplicationHeading title='Sachausgaben' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				children: GetSachkostenSkizzeLoewe(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Sachausgaben Übersicht',
				content: <SachkostenUebersichtSkizzeLoewe />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
const EigenmittelStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		return [
			{
				label: 'Eigen- und Drittmittel',
				content: (
					<>
						<ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />
						<Box sx={{ borderBottom: '1px solid #000', py: 1 }}>
							<InhaltWrapper>
								<Typography variant='body1'>
									<strong>Bitte geben Sie einen Eigenanteil an.</strong> Dieser muss für KMU mindestens 50% der angegebenen, eigenen Ausgaben
									betragen. Für Forschungseinrichtungen muss der Eigenanteil mindestens 10% der eigenen Ausgaben betragen.
								</Typography>
								<Typography>
									<strong>Ausnahme im Falle einer antragstellenden HAW im Modul B:</strong> hier beträgt der Eigenanteil 0%.
								</Typography>
							</InhaltWrapper>
						</Box>
					</>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				children: GetEigenmittelSkizzeLoewe(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EinnahmeUebersichtSkizzeLoewe />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
